import { gql } from "@apollo/client";

import { TRANSACTION_FRAGMENT } from "@graphql/fragments";

export const CREATE_ONE_TIME_DEPOSIT = gql`
  ${TRANSACTION_FRAGMENT}
  mutation createOneTimeDeposit($goalId: String!, $bankAccountId: String, $amountInCents: Int!) {
    createOneTimeDeposit(
      input: { goalId: $goalId, bankAccountId: $bankAccountId, amountInCents: $amountInCents }
    ) {
      ...TransactionFragment
    }
  }
`;
